module.exports = __webpack_public_path__ + "static/media/back.8dfb5192.webm";